import { render, staticRenderFns } from "./OrdenesSerTecPantalla.vue?vue&type=template&id=bfbaa3a2&"
import script from "./OrdenesSerTecPantalla.vue?vue&type=script&lang=ts&"
export * from "./OrdenesSerTecPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports